import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { loadListing, loadPerformance, loadPerformanceFuture } from '../../actions/data'
import { getAggs, getConstituents, getTickerListing } from '../../reducers/data'
import CurrentDetailsTable from './CurrentDetailsTable/CurrentDetailsTable'
import FutureDetailsTable from './FutureDetailsTable/FutureDetailsTable'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import CompText from './Compliance/CompText'
import './App.css'

library.add(faQuestionCircle, faCircleNotch)
class App extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      view: 'current', // Set an initial view
    };
  }
  componentDidMount() {
    this.props.loadPerformance()
    this.props.loadPerformanceFuture()
    this.props.loadListing()
  }

  render() {
    const { selectedEntityOption } = this.props

    if (selectedEntityOption && selectedEntityOption.length <= 0) {
      return (
        <div className='earnings-app' style={{ textAlign: 'center' }}>
          <FontAwesomeIcon icon='circle-notch' size='2x' style={{ color: '#050139', marginTop: '45px' }} spin />
        </div>
      )
    } else {
      return (
        <div>
          <div className='earnings pdfLink'>
            <a href='https://www.wisdomtree.com/-/media/us-media-files/documents/resource-library/DailyEarningsDashboard.pdf' target='_new'>
              <FontAwesomeIcon icon='file-pdf' size='1x' /> Download Daily Earnings Snapshot PDF
            </a>
          </div>
          <div>
            <button
              className={`earnings-type-buttons ${this.state.view === 'current' ? 'isselected' : 'notselected'}`}
              onClick={() => this.setState({ view: 'current' })}
            >
              Current
            </button>
            <button
              className={`earnings-type-buttons ${this.state.view === 'future' ? 'isselected' : 'notselected'}`}
              onClick={() => this.setState({ view: 'future' })}
            >
              Forward
            </button>

            {this.state.view === 'current' && (
              <div className='earnings-app-current'>
                <CurrentDetailsTable />
                <CompText />
              </div>
            )}
            {this.state.view === 'future' && (
              <div className='earnings-app-future'>
                <FutureDetailsTable />

              </div>
            )}

          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    earningsConstituents: getConstituents,
    selectedEntityOption: state.data.selectedEntityOption,
    earningsAggs: getAggs,
    earningsAggsFuture: getAggs,
    earningsTickerListing: getTickerListing,
    initialLoad: state.data.initialLoad,
    futureDataLoaded: state.data.futureDataLoaded,
    currentDataLoaded: state.data.currentDataLoaded,
    listingDataLoaded: state.data.listingDataLoaded
  }
}

export default connect(mapStateToProps, {
  loadPerformance,
  loadPerformanceFuture,
  loadListing
})(App)



// WEBPACK FOOTER //
// ./src/components/App/App.js